"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderLinearProgress = void 0;
var material_1 = require("@mui/material");
exports.BorderLinearProgress = (0, material_1.styled)(material_1.LinearProgress)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: '12px',
            borderRadius: '16px'
        },
        _b["&.".concat(material_1.linearProgressClasses.colorPrimary)] = {
            backgroundColor: "".concat(theme.palette.primary[200], "66"),
        },
        _b["& .".concat(material_1.linearProgressClasses.bar)] = {
            borderRadius: '16px',
            background: 'linear-gradient(90deg, #5029EF 30%, #DFE5F3 215.97%);',
        },
        _b);
});
